import React from 'react';
import ReactDOM from 'react-dom';
import pic from '../shared/Pic';

class LcPic extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default pic(LcPic, 'lc');


// WEBPACK FOOTER //
// ./src/components/sections/lc/LcPic.js